module.exports = __webpack_public_path__ + "static/media/LI.5661d6cf.svg";